import client from './client';

export const industryApi = {
  // 获取产量数据
  getProductionData: (params?: any) => {
    return client.get('/industry/production', { params });
  },

  // 获取贸易路线
  getTradeRoutes: (params?: any) => {
    return client.get('/industry/trade-routes', { params });
  },

  // 获取供需数据
  getSupplyDemandData: (params?: any) => {
    return client.get('/industry/supply-demand', { params });
  },

  // 获取产业链数据
  getIndustryChain: () => {
    return client.get('/industry/chain');
  }
};